import React, { Fragment, useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Stage, Layer, Rect, Star, Text, Transformer, Group, Label, Tag } from 'react-konva';
import ReactDOM from "react-dom";
import { Section } from '../../../../../../../redux/slices/template/templateModels';
import { getCorrespondWidth, getRealHeight, getRealWidth, getSectionIconUnicode, getSectionIconWidth } from '../../../../../../../redux/slices/editor/editorModels';
import { useAppDispatch, useAppSelector } from '../../../../../../../redux/hook';
import { toCapitalize } from '../../../../../../../redux/slices/content/contentModels';
import Swal from 'sweetalert2';
import { removeTemplatePosition } from '../../../../../../../redux/slices/template/templateSlice';
import { setTemplateSettings } from '../../../../../../../redux/slices/editor/editorSlice';


type SectInput = {
  // sectionProps  : any, 
  sectionProps  : Section, 

  isSelected    : boolean, 
  onSelect      : any, 
  onChange      : any
}
// ----------------------------

const TmpltSection = (sectInp : SectInput) => {
  const dispatch = useAppDispatch()  
  //-----------------------------------------
  
  const sectionRef= useRef<any>(null);
  const trRef     = useRef<any>(null);

  const currEditorW = useAppSelector(state => state.editor.currEditorWidth)
  const currEditorH = useAppSelector(state => state.editor.currEditorHeight)
  const currEditorZoom = useAppSelector(state => state.editor.zoomPercentage)

  const newTmpltSetting = useAppSelector(state => state.editor.templateToolsSettings)
  
  console.log("sectInp: ", sectInp)
  console.log("sectInp.sectionProps: ", sectInp.sectionProps)
  console.log("sectInp.sectionProps: ", {...sectInp.sectionProps})

  const resetXY = (sectProp: Section) => {
    return {...sectProp, x: 0, y: 0}
  }

  // --------------------------------------
  const handleDeletePosition = (selectedId="") => {

    if (selectedId){
      Swal.fire({
        title: 'Are you sure you want to remove this section?<h1 style="color:#331168; margin: 15px 0;">'+ selectedId +'</h1>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#9C258F',
        cancelButtonColor: '#E4E6EF',
        confirmButtonText: 'Continue',
        customClass: {          
          cancelButton: 'order-1 left-gap me-5',
          confirmButton: 'order-2',
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          dispatch(removeTemplatePosition(selectedId))
          dispatch(setTemplateSettings({...newTmpltSetting, selectedSect: ""})) 
        }
      })
    }
  }


  // const getSnapLines = excludedShape => {
  //   const stage = stageRef.current;
  //   if (!stage) return;

  //   const vertical = [];
  //   const horizontal = [];

  //   // We snap over edges and center of each object on the canvas
  //   // We can query and get all the shapes by their name property `shape`.
  //   stage.find(".shape").forEach(shape => {
  //     // We don't want to snap to the selected shape, so we will be passing them as `excludedShape`
  //     if (shape === excludedShape) return;

  //     const box = shape.getClientRect({ relativeTo: stage });
  //     vertical.push([box.x, box.x + box.width, box.x + box.width / 2]);
  //     horizontal.push([box.y, box.y + box.height, box.y + box.height / 2]);
  //   });

  //   return {
  //     vertical: vertical.flat(),
  //     horizontal: horizontal.flat(),
  //   };
  // };

  // const getShapeSnappingEdges = () => {
  //   const stage = stageRef.current;
  //   const tr = transformerRef.current;

  //   const box = tr.findOne(".back").getClientRect({ relativeTo: stage });
  //   const absPos = tr.findOne(".back").absolutePosition();

  //   return {
  //     vertical: [
  //       // Left vertical edge
  //       {
  //         guide: box.x,
  //         offset: absPos.x - box.x,
  //         snap: "start",
  //       },
  //       // Center vertical edge
  //       {
  //         guide: box.x + box.width / 2,
  //         offset: absPos.x - box.x - box.width / 2,
  //         snap: "center",
  //       },
  //       // Right vertical edge
  //       {
  //         guide: box.x + box.width,
  //         offset: absPos.x - box.x - box.width,
  //         snap: "end",
  //       },
  //     ],
  //     horizontal: [
  //       // Top horizontal edge
  //       {
  //         guide: box.y,
  //         offset: absPos.y - box.y,
  //         snap: "start",
  //       },
  //       // Center horizontal edge
  //       {
  //         guide: box.y + box.height / 2,
  //         offset: absPos.y - box.y - box.height / 2,
  //         snap: "center",
  //       },
  //       // Bottom horizontal edge
  //       {
  //         guide: box.y + box.height,
  //         offset: absPos.y - box.y - box.height,
  //         snap: "end",
  //       },
  //     ],
  //   };
  // };


  // ----------------------------------
  useEffect(() => {
    if (sectInp.isSelected) {
      // we need to attach transformer manually 
      // when the section is selected
      if (trRef.current){        
        trRef.current.nodes([sectionRef.current]);
        trRef.current.getLayer().batchDraw();
      }
    }
  }, [sectInp.isSelected]);

  // ------------------------------------
  return (
    <Fragment key={`${sectInp.sectionProps.key? sectInp.sectionProps.key : ""}--`}>
      <Group
        ref = {sectionRef}
        key = {sectInp.sectionProps.key? sectInp.sectionProps.key : ""}
        {...sectInp.sectionProps}        

        onClick = {sectInp.onSelect}
        onTap   = {sectInp.onSelect}        
        
        draggable
        onDragEnd={(e) => {          
          sectInp.onChange({
            ...sectInp.sectionProps,
            x: e.target.x(),
            y: e.target.y(),
          });
        }}
        
        onTransformEnd={(e) => {
          // transformer is changing scale of the node
          // and NOT its width or height
          // but in the store we have only width and height
          // to match the data better we will reset scale on transform end
          const node: any = sectionRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          // we will reset it back
          node.scaleX(1);
          node.scaleY(1);
          sectInp.onChange({
            ...sectInp.sectionProps,
            x: Math.round(node.x()),
            y: Math.round(node.y()),
            // set minimal value
            width : Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY),
          });
        }}
      >
        <Rect
          // ref     = {sectionRef}
          // key = {sectInp.sectionProps.key? sectInp.sectionProps.key : ""}
          // {...resetXY(sectInp.sectionProps)}
          {...sectInp.sectionProps}
          x = {0} //always 0 because the group is responsible for coordinate values
          y = {0} //always 0 because the group is responsible for coordinate values
          
          // shadowColor = 'white'
          // shadowBlur  = {2}
          // shadowOffset= {{ x: 1, y: 1 }}
          // shadowOpacity= {0.5}

          // onClick = {sectInp.onSelect}
          // onTap   = {sectInp.onSelect}        
          
          // draggable
          // onDragEnd={(e) => {
          //   sectInp.onChange({
          //     ...sectInp.sectionProps,
          //     x: e.target.x(),
          //     y: e.target.y(),
          //   });
          // }}
          
          // onTransformEnd={(e) => {
          //   // transformer is changing scale of the node
          //   // and NOT its width or height
          //   // but in the store we have only width and height
          //   // to match the data better we will reset scale on transform end
          //   const node: any = sectionRef.current;
          //   const scaleX = node.scaleX();
          //   const scaleY = node.scaleY();

          //   // we will reset it back
          //   node.scaleX(1);
          //   node.scaleY(1);
          //   sectInp.onChange({
          //     ...sectInp.sectionProps,
          //     x: Math.round(node.x()),
          //     y: Math.round(node.y()),
          //     // set minimal value
          //     width : Math.max(5, node.width() * scaleX),
          //     height: Math.max(node.height() * scaleY),
          //   });
          // }}
        />
        {/* close button */}
        <Label                  
          opacity= {0.75}          
        >
          <Tag 
            fill  = 'white'
            opacity= {0.5}
          />
          <Text
            fontSize={10}
            fontFamily= "FontAwesome"
            text  = {`${getSectionIconUnicode(sectInp.sectionProps.type)}`}
            align = "center"
            padding={8}
            fill  = 'black'
          />        
        </Label>
        <Label                  
          opacity= {0.75}
          x={getSectionIconWidth(sectInp.sectionProps.type)}
        >
          <Tag 
            fill  = 'white'
            opacity= {0.5}
            cornerRadius = {[0, 0, 5, 0]}
          />
          <Text
            fontSize={10}
            text  = {`${sectInp.sectionProps.id} [${getRealWidth( sectInp.sectionProps.width, sectInp.sectionProps.height, currEditorW, currEditorH, currEditorZoom)}x${getRealHeight( sectInp.sectionProps.width, sectInp.sectionProps.height, currEditorW, currEditorH, currEditorZoom)}]`}
            align = "center"
            padding={8}
            fill  = 'black'
          />        
        </Label>

        {/* close button */}
        <Label
          x= {sectInp.sectionProps.width - 23}
          y= {0}           
          opacity= {0.75}
          onClick={()=> handleDeletePosition(sectInp.sectionProps.id)}
        >
          <Tag 
            fill  = 'white'
            cornerRadius = {[0, 0, 0, 5]}
            opacity= {0.5}
          />
          <Text
            fontSize={10}
            fontFamily= "FontAwesome"
            text  = {`\uf00d`}            
            align = "center"            
            padding={8}
            fill  = 'black'
          />        
        </Label>
      </Group>

      {sectInp.isSelected && (
        <Transformer
          ref={trRef}
          flipEnabled={false}
          rotateEnabled={false}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (Math.abs(newBox.width) < 5 || Math.abs(newBox.height) < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </Fragment>
  );
};

export default TmpltSection;

// ----------------------------
